var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunnyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16C9.22387 16 9 16.2773 9 16.6194V18.3806C9 18.7227 9.22387 19 9.5 19C9.7762 19 10 18.7227 10 18.3806V16.6194C10 16.2773 9.77613 16 9.5 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3C9.7762 3 10 2.72268 10 2.38061V0.619391C10 0.277322 9.7762 0 9.5 0C9.22387 0 9 0.277322 9 0.619391V2.38061C9 2.72268 9.22387 3 9.5 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72337 14.2189L2.21921 15.7228C1.92703 16.0149 1.92693 16.4886 2.21891 16.7807C2.365 16.9269 2.55646 17 2.74792 17C2.93928 17 3.13054 16.927 3.27663 16.781L4.78079 15.2772C5.07297 14.9851 5.07307 14.5114 4.78109 14.2192C4.48891 13.927 4.01545 13.927 3.72337 14.2189Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7479 5C14.9393 5 15.1307 4.92699 15.2768 4.78096L16.7809 3.27722C17.073 2.98507 17.0731 2.51149 16.7811 2.21924C16.489 1.92699 16.0154 1.92689 15.7232 2.21914L14.2191 3.72288C13.927 4.01493 13.9269 4.48861 14.2189 4.78076C14.3649 4.92699 14.5564 5 14.7479 5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5C3 9.22387 2.72266 9 2.38057 9H0.619425C0.277337 9 0 9.22387 0 9.5C0 9.77613 0.277337 10 0.619425 10H2.38057C2.72266 10 3 9.77613 3 9.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3807 9H16.6193C16.2772 9 16 9.22387 16 9.5C16 9.77613 16.2772 10 16.6193 10H18.3807C18.7228 10 19 9.77613 19 9.5C19 9.22393 18.7228 9 18.3807 9Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72294 4.78095C3.86897 4.92698 4.06049 5 4.25191 5C4.44333 5 4.63484 4.92698 4.78088 4.78095C5.07304 4.48879 5.07304 4.01509 4.78088 3.72292L3.27706 2.21912C2.9849 1.92696 2.51119 1.92696 2.21912 2.21912C1.92696 2.51128 1.92696 2.98499 2.21912 3.27705L3.72294 4.78095Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2773 14.2192C14.9851 13.927 14.5114 13.9269 14.2192 14.2191C13.9269 14.5112 13.9269 14.985 14.2191 15.277L15.7227 16.7808C15.8689 16.927 16.0603 17 16.2518 17C16.4432 17 16.6348 16.927 16.7808 16.7809C17.0731 16.4888 17.0731 16.0151 16.7809 15.723L15.2773 14.2192Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.00009C4 6.24305 6.24289 4 8.99979 4C11.7569 4 14 6.24305 14 9.00009C14 11.757 11.7569 14 8.99979 14C6.24289 14 4 11.757 4 9.00009ZM5.28479 9.00009C5.28479 11.0486 6.95132 12.7152 8.99979 12.7152C11.0485 12.7152 12.7152 11.0486 12.7152 9.00009C12.7152 6.95147 11.0485 5.28477 8.99979 5.28477C6.95132 5.28477 5.28479 6.95147 5.28479 9.00009Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunnyDay);
export default __webpack_public_path__ + "static/media/sunny-day.534ef1ee5031caad883b5aa78cd9846c.svg";
export { ForwardRef as ReactComponent };